"use strict";
import React, { useEffect, useRef } from "react";
import "./ECLToast.css";
import { ECLThemeImage } from "../../index.js";
import { translate } from "../../../utilities/Translate.js";

// PROPS:
// Toasts [{string, string}] themselves will have two properties, a message and a kind.  Kind will determine the styling the toast receives.
// Pop [func] is a function for clearing the first toast in the toaster (Optionally can include an index, but that's future functionality)
// Multi [bool] describes to this component whether there is more than one outstanding toast
export default function ECLToast({ pop, toast, multi }) {
   // Carry timeOutRef to terminate time outs if a user clicks a notification close
   const closeFocus = useRef(null);

   //When the render updates, start the timer
   useEffect(() => {
      closeFocus.current.focus();
      const timeOut = setTimeout(function () {
         pop();
      }, 50000);
      return () => {
         clearInterval(timeOut);
      };
   });

   // that glob in the paragraph element allows us to parse objects into strings ([object object] gets turned to JSON)
   // and saves us an extra use effect when we're waiting for display to update
   return (
      <div className={toast.kind} id="toast-container" role="alertdialog">
         <div className="toast-message-body">
            <div className="toast-message-header">
               {toast.kind === "error" ? (
                  <ECLThemeImage
                     fontAwesome="triangle-exclamation"
                     alt={translate("Error Icon")}
                  />
               ) : (
                  <ECLThemeImage
                     fontAwesome="bell"
                     alt={translate("Information Icon")}
                  />
               )}
               <h3>{toast.kind === "error" ? "Alert" : "Notice"}</h3>
            </div>
            <p>
               {typeof toast.body === "object"
                  ? JSON.stringify(toast.body, null, 1)
                  : toast.body}
            </p>
         </div>
         <button
            onClick={pop}
            name={toast.body}
            data-kind={toast.kind}
            ref={closeFocus}
         >
            {multi ? (
               <ECLThemeImage
                  fontAwesome="arrow-right"
                  alt={translate("Next message icon")}
               />
            ) : (
               <ECLThemeImage
                  fontAwesome="xmark"
                  alt={translate("Close window icon")}
               />
            )}
         </button>
      </div>
   );
}
